import React from 'react';
import { useLoginFormPresenter } from './LoginForm.presenter';

import { Link } from 'components/uikit/Link/Link';
import { ECreditARBLogoMImg } from 'assets/images';
import { CrossMIcon } from 'assets/icons';

import * as S from './LoginForm.styles';

export const LoginForm = ({ dataTest = 'loginForm' }) => {
  const presenter = useLoginFormPresenter();
  const { login, password } = presenter.authData;

  return (
    <S.Container data-test={dataTest}>
      <ECreditARBLogoMImg />
      <S.Wrapper loginFirstRender={presenter.loginFirstRender}>
        <S.EmailInput
          name="email"
          type="email"
          value={login}
          label="Почта"
          validate={presenter.validateLogin}
          error={presenter.getLoginError()}
          ClearButton={CrossMIcon}
          dataTest={`${dataTest}-loginInput`}
          onChange={presenter.onLoginChangeHandler}
          onBlur={presenter.onLoginBlurHandler}
          onKeyDown={presenter.onHandleKeyDown}
          autoComplete="username"
        />

        {!presenter.loginFirstRender && (
          <S.PasswordInput
            name="password"
            type="password"
            value={password}
            label="Пароль"
            validate={presenter.validatePassword}
            error={presenter.getPasswordError()}
            ClearButton={CrossMIcon}
            dataTest={`${dataTest}-passwordInput`}
            onChange={presenter.onPasswordChangeHandler}
            onBlur={presenter.onPasswordBlurHandler}
            onKeyDown={presenter.onHandleKeyDown}
            autoComplete="current-password"
          />
        )}
        {presenter.loginFirstRender ? (
          <S.NextButton onClick={() => presenter.onNextButtonClick(presenter.loginFirstRender)}>
            Далее
          </S.NextButton>
        ) : (
          <S.LoginButton onClick={presenter.onHandleSubmit}>Войти</S.LoginButton>
        )}
      </S.Wrapper>
      {presenter.loginFirstRender ? (
        <S.TextWrapper loginFirstRender={presenter.loginFirstRender}>
          <S.Description>Нет учётной записи?</S.Description>
          <Link
            href={'https://www.ecredit.one/#popup:subscribe'}
            target={'_blank'}
            fontWeight={'regular'}
          >
            Зарегистрируйтесь
          </Link>
        </S.TextWrapper>
      ) : (
        <Link fontWeight={'regular'} onClick={() => presenter.onNextButtonClick()}>
          Вернуться назад
        </Link>
      )}
      <S.TextWrapper loginFirstRender={presenter.loginFirstRender}>
        {!presenter.loginFirstRender && (
          <S.Approval>
            Для восстановления пароля <br />
            <Link
              theme={'2'}
              size={'xs'}
              onClick={() => window.open('mailto:help-ecredit@business.auto.ru', '_blank')}
            >
              help-ecredit@business.auto.ru
            </Link>{' '}
            или <S.PhoneNumber>+7 (495) 120-13-67</S.PhoneNumber>
          </S.Approval>
        )}
        <S.Approval>
          Авторизуясь на сайте, я даю согласие на{' '}
          <Link
            size={'xs'}
            href={'https://yandex.ru/legal/confidential/'}
            target={'_blank'}
            fontWeight={'regular'}
          >
            обработку персональных данных
          </Link>{' '}
          в соответствии
          <br /> с законодательством России
        </S.Approval>
      </S.TextWrapper>
    </S.Container>
  );
};
